import { useTheme } from '@/components/theme-provider';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Monitor, Moon, Sun } from 'lucide-react';

const TabModeToggle = () => {
  const { setTheme, theme } = useTheme();
  return (
    <>
      <Tabs
        defaultValue={theme}
        onValueChange={(e) => setTheme(e as typeof theme)}
        className="h-full"
      >
        <TabsList className="grid h-full grid-cols-3 p-1">
          <TabsTrigger value="light" className="px-2 py-1">
            <Sun className="h-[0.8rem] w-[0.8rem]" />
          </TabsTrigger>
          <TabsTrigger value="dark" className="px-1 py-1">
            <Moon className="h-[0.8rem] w-[0.8rem]" />
          </TabsTrigger>
          <TabsTrigger value="system" className="px-1 py-1">
            <Monitor className="h-[0.8rem] w-[0.8rem]" />
          </TabsTrigger>
        </TabsList>
      </Tabs>
    </>
  );
};

export default TabModeToggle;
